import React from "react";

import { biennaleTags, montserratTags } from "./fonts-components";

export type Font = "biennale" | "montserrat";
export type FontsProps = {
  fonts?: Font | Font[];
  children?: React.ReactNode;
};

export const Fonts = ({ fonts = "biennale" }: FontsProps) => {
  return <React.Fragment>{getFontTags({ fonts })}</React.Fragment>;
};

Fonts.displayName = "Fonts";

export const getFontTags = ({ fonts = "biennale" }: FontsProps = {}) => {
  const fontList = Array.isArray(fonts) ? fonts : [fonts];

  return fontList.map((font) => {
    switch (font) {
      case "biennale": {
        return biennaleTags;
      }
      case "montserrat": {
        return montserratTags;
      }
      default: {
        return null;
      }
    }
  });
};

export default Fonts;
